module.exports = __webpack_public_path__ + "img/myMuscleChef.a75d05e0.png";